import { BcIconProps } from "../../interface/props/bcicon";


const BcIcon = ({iconName, ariaLabel, size, addClass }: BcIconProps) => {
    return(
        <em className={`bc-icon ${size ? size : 'bc-sm'} ${addClass ? addClass : null}`} aria-label={ariaLabel} >{iconName}</em>
    )
}

export default BcIcon;